import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDBijiUHeeqtgcuW7-1tT4grC29semhfqQ",
  authDomain: "sendtotool-a87ghe.firebaseapp.com",
  projectId: "sendtotool-a87ghe",
  storageBucket: "sendtotool-a87ghe.firebasestorage.app",
  messagingSenderId: "1013157340958",
  appId: "1:1013157340958:web:8ff7fd4b036ebaf54a0b0f",
  measurementId: "G-B1EHKN0LRM",
};

const getFirebaseApp = () => {
  const app = initializeApp(firebaseConfig);

  return app;
};

const getFirebaseDB = () => {
  const db = getFirestore(getFirebaseApp);
  return db;
};

export { firebaseConfig, getFirebaseApp, getFirebaseDB };

// Initialize Firebase
//const analytics = getAnalytics(app);
